import { ActionButton, Divider, Flex, Heading, View } from '@adobe/react-spectrum';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { useNavigate } from 'react-router-dom';
import SearchStudent from './searchStudent';
import { useState } from 'react';
import { StudentPaymentData } from '../../types';
import PaymentDetailsOverview from './paymentDetailsOverview';
import { paymentDataForStudent } from '../constant';

const NewPayment = () => {
  const navigate = useNavigate();
  const [studentData, setStudentData] = useState<StudentPaymentData>(paymentDataForStudent);
  return (
    <View minHeight={'87vh'}>
      <Flex justifyContent={'space-between'}>
        <Flex>
          <ActionButton isQuiet onPress={() => navigate(-1)}>
            <ArrowBackIosIcon fontSize="small" />
          </ActionButton>
          <Heading margin={'size-50'}>Create Payment</Heading>
        </Flex>
      </Flex>
      <Divider size="M" marginTop={'size-100'} />
      <SearchStudent setStudentData={setStudentData} />
      {studentData && <PaymentDetailsOverview studentData={studentData} />}
    </View>
  );
};

export default NewPayment;
